module.exports = __webpack_public_path__ + "img/NORIC.c47de4b3.jpg";